module.exports = __webpack_public_path__ + "static/media/talkmore-icons.faf826ab.eot";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/talkmore-icons.eot
// module id = 118
// module chunks = 0